import React__default, { useMemo } from 'react';
import { useQueryIntegration } from '../../connections/queries/useQueryIntegration.js';

const useGetFolderIntegration = (folder) => {
  const rootId = folder?.root?.id;
  const { integration, isLoading } = useQueryIntegration({
    rootId
  });
  const isFolderRootOfIntegration = useMemo(() => !!folder && !!folder?.id && folder?.id === folder?.root?.folder.id || false, [
    folder
  ]);
  return React__default.useMemo(() => {
    if (!integration) {
      return {
        isLoading,
        folderIntegration: null,
        isFolderRootOfIntegration: false,
        folderMirror: null
      };
    }
    const mirror = integration.mirrorRegistries.find((mirror2) => mirror2.rootId === rootId);
    return {
      isLoading,
      folderIntegration: integration,
      folderMirror: mirror,
      isFolderRootOfIntegration
    };
  }, [
    integration,
    isFolderRootOfIntegration,
    isLoading,
    rootId
  ]);
};

export { useGetFolderIntegration };
//# sourceMappingURL=useGetFolderIntegration.js.map
